import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SicotService } from '../sicot.service';
import { OperationStatusItem } from '../types/OperationStatus';
import { StatoFhirDialogComponent } from './stato-fhir-dialog/stato-fhir-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-richieste-valutazione',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule
  ],
  templateUrl: './admin-richieste-valutazione.component.html',
  styleUrl: './admin-richieste-valutazione.component.css'
})
export class AdminRichiesteValutazioneComponent implements OnInit {

  items: OperationStatusItem[] = [];
  caricamento = true;
  errore: string | null = null;
  displayedColumns: string[] = ['operationId', 'status', 'errorMessage', 'actions'];

  totalElements = 0;
  pageIndex = 0;
  pageSize = 20;
  pageSizeOptions = [10, 20, 50];

  private readonly sicotService = inject(SicotService);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.loadPage();
  }

  loadPage(): void {
    this.caricamento = true;
    this.errore = null;
    this.sicotService.getRichiestaValutazioneOperations(this.pageIndex, this.pageSize).subscribe({
      next: (page) => {
        this.items = page.content;
        this.totalElements = page.totalElements;
        this.caricamento = false;
      },
      error: () => {
        this.errore = 'Errore nel caricamento delle richieste.';
        this.caricamento = false;
      }
    });
  }

  onPage(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadPage();
  }

  openStatoFhirPopup(operationId: string): void {
    this.dialog.open(StatoFhirDialogComponent, {
      data: { operationId },
      width: '520px',
    });
  }

  refreshRow(item: OperationStatusItem): void {
    this.sicotService.getRichiestaValutazioneStatus(item.operationId).subscribe({
      next: (task) => {
        item.status = task.extension?.find(e => e.url?.includes('operationStatus'))?.valueString ?? task.status;
        const errExt = task.extension?.find(e => e.url?.includes('operationErrorMessage'));
        item.errorMessage = errExt?.valueString ?? undefined;
      },
      error: () => { /* ignore */ }
    });
  }

  statusLabel(status: string): string {
    const map: Record<string, string> = {
      'PENDING': 'In attesa',
      'RUNNING': 'In elaborazione',
      'SUCCEEDED': 'Completata',
      'FAILED': 'Fallita'
    };
    return map[status] ?? status;
  }
}
